import {
  USER_FIELD_FILTER_REQUEST,
  USER_FIELD_FILTER_REQUEST_SUCCESS,
  USER_FIELD_FILTER_REQUEST_FAILURE,
  USER_FIELD_FILTER_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const userFilterFieldsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case USER_FIELD_FILTER_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case USER_FIELD_FILTER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case USER_FIELD_FILTER_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case USER_FIELD_FILTER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default userFilterFieldsReducer;
